import styled from "styled-components";

export const Wrapper = styled.div`

`
export const ModalContent = styled.div`
    padding: 10px;
    margin-top: 100px;
    h3{
    margin: 0;
    padding: 0;
    font-size: 24px;
    text-align: center;
    color: #213a66;
}

`
export const Buttons = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 144px;
button{
    margin: 0; 
    font-family: sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    text-transform: uppercase;
    color: white;
    border-radius: 15px;
    background: #F67263;
    padding: 10px 70px;
    border: transparent;
    cursor: pointer;

}
`